import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';

import {environment} from '../../../../environments/environment';
import { catchError } from 'rxjs/operators';

type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({providedIn: 'root'})
export class EHSExternalService {

  public resourceUrl = environment.serverURL + '/api/ehs-external';

  constructor(protected http: HttpClient) {
  }

  create(ehs: any): Observable<EntityResponseType> {
    return this.http.post<any>(this.resourceUrl, ehs, {observe: 'response'});
  }

  find(id: string): Observable<EntityResponseType> {
    return this.http.get<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }


}
